// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"06e838ea","214":"fb6cdca4","681":"be1618b2"}[chunkId] + ".chunk.css";
};